import { QueryKeys } from "@/constants/query-keys";
import { QueryClient } from "@tanstack/react-query";

export const recreatePlanInvalidateQueries = (queryClient: QueryClient) => {
  // Remove PLAN cache entirely to force loading spinner on my plan page
  queryClient.removeQueries({ queryKey: [QueryKeys.PLAN] });
  queryClient.invalidateQueries({ queryKey: [QueryKeys.SHOPPING_LIST] });
  queryClient.invalidateQueries({
    predicate(query) {
      return query.queryKey.includes(QueryKeys.PLAN_ALTERNATIVE_FILTER_OPTIONS);
    },
  });
};
